// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cost-breakdown-tooltip--WeZcq .tooltip-inner{max-width:none;width:-moz-max-content;width:max-content}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cost-breakdown-tooltip": "cost-breakdown-tooltip--WeZcq"
};
export default ___CSS_LOADER_EXPORT___;
